export default __webpack_public_path__ + "static/media/i248sp.604edfbd.webp";